import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import tokens from './tokens';
import tokensToCssVars from './tokensToCssVars';

const rootVars = { ':root': tokensToCssVars(tokens) };

export default function ThemeCssVariables() {
  return <GlobalStyles styles={rootVars} />;
}
